document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.maison-product-card').forEach(card => {
    const images = card.querySelectorAll('.variant-image');
    const swatches = card.querySelectorAll('.lumin-variant-image');

    swatches.forEach(swatch => {
      const color = swatch.dataset.color;

      swatch.addEventListener('mouseenter', () => {
        images.forEach(img => {
          img.classList.toggle('active', img.dataset.color === color);
        });

        swatches.forEach(s => s.classList.remove('active'));
        swatch.classList.add('active');
      });
    });
  });

document.querySelectorAll(".maison-product-card__more-colors").forEach(button => {
  button.addEventListener("click", function () {
    const wrapper = button.closest(".maison-product-card__variants");
    const swatches = wrapper.querySelectorAll(".swatch");

    const isExpanded = button.classList.contains("expanded");

    if (!isExpanded) {
      swatches.forEach((swatch, i) => {
        if (swatch.style.display === "none" || window.getComputedStyle(swatch).display === "none") {
          swatch.style.display = "inline-block";
          swatch.classList.add("swatch--fade-in");
          swatch.style.transitionDelay = `${i * 0.05}s`;
        }
      });

      button.classList.add("expanded");
    } else {
      swatches.forEach((swatch, i) => {
        if (i > 4) {
          swatch.style.display = "none";
          swatch.classList.remove("swatch--fade-in");
          swatch.style.transitionDelay = "0s";
        }
      });

      button.classList.remove("expanded");
    }
  });
});

});